"use client";

import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styles from "./Header.module.css";
import logo from "../../assets/Gq.png";
import { AiOutlineUp, AiOutlineDown, AiOutlineClose } from "react-icons/ai";

function Header() {
  const [selectedKey, setSelectedKey] = useState("1");
  const location = useLocation();
  const navigate = useNavigate();
  const [showNosotrosDropdown, setShowNosotrosDropdown] = useState(false);
  const [showServiciosDropdown, setShowServiciosDropdown] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const dropdownRef = useRef(null);

  // Detectar si es móvil
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    return () => {
      window.removeEventListener("resize", checkIfMobile);
    };
  }, []);

  useEffect(() => {
    const path = location.pathname;
    switch (path) {
      case "/":
        setSelectedKey("1");
        break;
      case "/Nosotros":
        setSelectedKey("2");
        break;
      case "/Servicios":
        setSelectedKey("3");
        break;
      case "/Blog":
        setSelectedKey("4");
        break;
      case "/Suscribete":
        setSelectedKey("5");
        break;
      case "/Tienda":
        setSelectedKey("6");
        break;
      default:
        setSelectedKey("1");
    }
  }, [location]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowNosotrosDropdown(false);
        setShowServiciosDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleMenuClick = (key) => {
    setSelectedKey(key);
    setShowNosotrosDropdown(false);
    setShowServiciosDropdown(false);
  };

  const toggleDropdown = (dropdown) => {
    if (dropdown === "nosotros") {
      // Añadimos console.log para debug
      console.log("Toggling nosotros dropdown", !showNosotrosDropdown);
      setShowNosotrosDropdown(!showNosotrosDropdown);
      setShowServiciosDropdown(false);
    } else if (dropdown === "servicios") {
      setShowServiciosDropdown(!showServiciosDropdown);
      setShowNosotrosDropdown(false);
    }
  };

  // Datos originales para PC
  const serviciosFaciales = [
    ["Bruxismo", "Contorno mandibular"],
    ["Enzimas", "Exosomas"],
    ["Estimuladores de colageno", "Hidratación"],
    ["Hiperhidrosis", "Hydrafacial®"],
    ["Limpieza", "Labios"],
    ["Mentón", "Nanopore"],
    ["Ojeras", "Peeling"],
    ["Pómulos", "Plasma"],
    ["Acido hialuronico", "Rinomodelacion"],
    ["Surcos", "Sustentación"],
    ["Toxina Botulinica", "radiofrecuencia"],
    ["Radiofrecuencia fraccionada con microagujas", "Fototerapia"],
  ];

  const serviciosCorporales = [
    ["Enzimas 2 generación", "Sueroterapia"],
    ["Tensamax", "EMSculpt"],
    [
      "Radiofrecuencia fraccionada con microagujas corporal",
      "Masajes reductores y moldeamiento",
    ],
    ["Tratamiento para celulitis", "Maderoterapia"],
    ["Masaje relajante", ""],
  ];

  const serviciosCapilares = [
    "Exosomas capílar",
    "Mesocapilar",
    "Plasma capilar",
  ];

  // Datos planos para móviles
  const serviciosFacialesPlanos = [
    "Bruxismo",
    "Contorno mandibular",
    "Enzimas",
    "Exosomas",
    "Estimuladores de colageno",
    "Hidratación",
    "Hiperhidrosis",
    "Hydrafacial®",
    "Limpieza",
    "Labios",
    "Mentón",
    "Nanopore",
    "Ojeras",
    "Peeling",
    "Pómulos",
    "Plasma",
    "Acido hialuronico",
    // "Rinomodelacion",
    "Surcos",
    "Sustentación",
    "Toxina Botulinica",
    "radiofrecuencia",
    // "Radiofrecuencia fraccionada con microagujas",
    "Fototerapia",
  ];

  const serviciosCorporalesPlanos = [
    "Enzimas 2 generación",
    "Sueroterapia",
    "Tensamax",
    "EMSculpt",
    "Radiofrecuencia fraccionada con microagujas corporal",
    "Masajes reductores y moldeamiento",
    "Tratamiento para celulitis",
    "Maderoterapia",
    "Masaje relajante",
  ];

  const serviciosCapilaresPlanos = [
    "Exosomas capílar",
    "Mesocapilar",
    "Plasma capilar",
  ];

  // Función auxiliar para crear enlaces de servicios de manera segura
  const renderServiceLink = (servicio, index) => {
    // Verificar que servicio sea una cadena de texto y no esté vacío
    if (typeof servicio === "string" && servicio.trim() !== "") {
      // Determinar si es alguno de los servicios de radiofrecuencia con texto largo
      const isRadioFacial = servicio.includes(
        "Radiofrecuencia fraccionada con microagujas"
      );
      const isRadioCorporal = servicio.includes(
        "Radiofrecuencia fraccionada con microagujas corporal"
      );
      const isColageno = servicio.includes("Estimuladores de colageno");
      const isenzimas = servicio.includes("Enzimas 2 generación");
      const ismoldeamiento = servicio.includes(
        "Masajes reductores y moldeamiento"
      );
      const iscelulitis = servicio.includes("Tratamiento para celulitis");
      const needsSpecialClass =
        isRadioFacial ||
        isRadioCorporal ||
        isColageno ||
        isenzimas ||
        ismoldeamiento ||
        iscelulitis;

      // Aplicar clases especiales solo si es uno de los servicios específicos
      const className = `${styles.serviceLink} ${
        needsSpecialClass ? `${styles.longText} ${styles.radiofrecuencia}` : ""
      }`;

      return (
        <Link
          key={index}
          to={`/servicios/${servicio.toLowerCase().replace(/\s+/g, "-")}`}
          className={className}
          onClick={() => {
            setShowServiciosDropdown(false);
            setShowNosotrosDropdown(false);
          }}
        >
          {servicio}
        </Link>
      );
    }
    return null;
  };

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <Link to="/">
          <img
            className={styles.image}
            src={logo || "/placeholder.svg"}
            alt="Logo"
          />
        </Link>

        <nav className={styles.menu} ref={dropdownRef}>
          <ul>
            {/* Enlace Inicio agregado */}
            <li className={selectedKey === "1" ? styles.selected : ""}>
              <Link to="/" onClick={() => handleMenuClick("1")}>
                Inicio
              </Link>
            </li>

            <li
              className={`${selectedKey === "2" ? styles.selected : ""} ${
                styles.dropdown
              }`}
            >
              <button
                onClick={() => toggleDropdown("nosotros")}
                className={styles.dropdownButton1}
                aria-expanded={showNosotrosDropdown}
              >
                Nosotros
                <span className={styles.arrow}>
                  {showNosotrosDropdown ? <AiOutlineUp /> : <AiOutlineDown />}
                </span>
              </button>
              {showNosotrosDropdown && (
                <div className={styles.dropdownContent}>
                  <button
                    className={styles.closeButton}
                    onClick={() => setShowNosotrosDropdown(false)}
                  >
                    <AiOutlineClose />
                  </button>
                  {/* Sección modificada */}
                  <div className={styles.nosotrosSection}>
                    <h3>Nosotros</h3>
                    <Link
                      to="/Nosotros"
                      className={styles.serviceLink}
                      onClick={() => setShowNosotrosDropdown(false)}
                    >
                      Conócenos
                    </Link>
                    <p className={styles.nosotrosDescription}>
                      Dra. Gladys Eugenia Quintero Capera
                      <br />
                      Médica Estética | Especialista en Medicina Regenerativa y
                      Antienvejecimiento
                    </p>
                  </div>
                </div>
              )}
            </li>

            <li
              className={`${selectedKey === "3" ? styles.selected : ""} ${
                styles.dropdown
              }`}
            >
              <button
                onClick={() => toggleDropdown("servicios")}
                className={styles.dropdownButton}
                aria-expanded={showServiciosDropdown}
              >
                Servicios
                <span className={styles.arrow}>
                  {showServiciosDropdown ? <AiOutlineUp /> : <AiOutlineDown />}
                </span>
              </button>
              {showServiciosDropdown && (
                <div className={styles.serviciosDropdown}>
                  <button
                    className={styles.closeButton}
                    onClick={() => setShowServiciosDropdown(false)}
                  >
                    <AiOutlineClose />
                  </button>
                  {/* Diseño original para PC */}
                  <div
                    className={`${styles.serviciosSection} ${styles.facialDivider}`}
                  >
                    <h3>Facial</h3>
                    <div className={styles.facialGrid}>
                      {/* Servicios Faciales - Aplanamos el array y verificamos cada servicio */}
                      {serviciosFaciales
                        .flat()
                        .map((servicio, index) =>
                          renderServiceLink(servicio, `facial-${index}`)
                        )}
                    </div>
                  </div>
                  <div
                    className={`${styles.serviciosSection} ${styles.corporalDivider}`}
                  >
                    <h3>Corporal</h3>
                    <div className={styles.singleColumnList}>
                      {/* Servicios Corporales - Aplanamos el array y verificamos cada servicio */}
                      {serviciosCorporales
                        .flat()
                        .map((servicio, index) =>
                          renderServiceLink(servicio, `corporal-${index}`)
                        )}
                    </div>
                  </div>
                  <div className={styles.serviciosSection}>
                    <h3>Capilar</h3>
                    <div className={styles.singleColumnList}>
                      {/* Servicios Capilares - Ya es un array plano, solo verificamos cada servicio */}
                      {serviciosCapilares.map((servicio, index) =>
                        renderServiceLink(servicio, `capilar-${index}`)
                      )}
                    </div>
                  </div>

                  {/* Diseño de 3 columnas para móviles */}
                  <div className={styles.serviciosCategorias}>
                    <div>
                      <h3 className={styles.categoriaTitle}>Facial</h3>
                      <div className={styles.serviciosGrid}>
                        {serviciosFacialesPlanos.map((servicio, index) =>
                          renderServiceLink(servicio, `facial-mobile-${index}`)
                        )}
                      </div>
                    </div>

                    <div>
                      <h3 className={styles.categoriaTitle}>Corporal</h3>
                      <div className={styles.serviciosGrid}>
                        {serviciosCorporalesPlanos.map((servicio, index) =>
                          renderServiceLink(
                            servicio,
                            `corporal-mobile-${index}`
                          )
                        )}
                      </div>
                    </div>

                    <div>
                      <h3 className={styles.categoriaTitle}>Capilar</h3>
                      <div className={styles.serviciosGrid}>
                        {serviciosCapilaresPlanos.map((servicio, index) =>
                          renderServiceLink(servicio, `capilar-mobile-${index}`)
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </li>

            {/* Secciones comentadas
            <li className={selectedKey === "4" ? styles.selected : ""}>
              <Link to="/Blog" onClick={() => handleMenuClick("4")}>
                Blog
              </Link>
            </li>
            <li className={selectedKey === "5" ? styles.selected : ""}>
              <Link to="/Suscribete" onClick={() => handleMenuClick("5")}>
                Suscríbete
              </Link>
            </li>
            <li className={selectedKey === "6" ? styles.selected : ""}>
              <Link to="/Tienda" onClick={() => handleMenuClick("6")}>
                Tienda
              </Link>
            </li>
            */}
          </ul>
        </nav>

        <div className={styles.contact}>
          <Link to="/contactanos">
            <button>CONTACTANOS</button>
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
